import React from "react";

export default function GetPtorReason({ ptorReasonsList, ptorIndex }) {
  const searchType = ptorReasonsList.find((ptor) => ptor.id == ptorIndex);
  return searchType ? searchType.title : "לא מוגדר";
}
